import { Button } from '@mui/material';
import * as React from 'react';
import UpgradeAccount from 'assets/images/upgrade-account.png';
import { useSegment } from 'common/hooks/segment';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPage, Routes } from 'constants/pages';

export const Upgrade: React.FC = () => {
  const { track } = useSegment();
  const { pathname } = useLocation();
  const page = getPage(pathname);

  const navigate = useNavigate();

  const handleClick = () => {
    track(
      'User clicked upgrade CTA',
      {
        source: page?.title || '',
        route: pathname,
      },
      { includeUser: true }
    );
    navigate(Routes.Plans);
  };

  return (
    <div className="flex flex-col justify-center items-center pb-12 pt-8 space-y-6">
      <img src={UpgradeAccount} alt="Upgrade account" className="w-32" />
      <div className="text-center space-y-8 max-w-[555px]">
        <div className="space-y-6">
          <h1 className="font-medium">Upgrade your account to get this report!</h1>
          <p>
            You have used all of your Per Diem credits availabe in your Free Trial plan. Please
            upgrade your account to get more Per Diem reports!
          </p>
        </div>
        <Button variant="contained" size="large" onClick={handleClick}>
          <h3>Upgrade my account</h3>
        </Button>
      </div>
    </div>
  );
};
Upgrade.displayName = 'SmartPerDiem.DownloadModal.Upgrade';
